/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FileSaver from 'file-saver';
import { debounce } from 'lodash';
import { getErrorCode } from 'util/errors';

import i18n from 'util/i18n';
import { formConfig } from 'config/forms';
import env from 'config/environment';

import { api } from 'services';

import Spinner, { SpinnerAction } from 'components/Form/Spinner';

import { validateForm } from '@redux/modules/form/actions';
import { Redirect } from 'react-router';
import Show from 'components/Form/Show';
import { saveAllForPDFRequest, startSubmission } from '@redux/modules/save/actions';
import { submissionTypes } from '@redux/modules/save/reducer';
import {
  SF85, SF85P, SF85PS, SF86, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D,
} from 'constants/formTypes';
import SvgComponent from 'components/Form/SvgComponent';
import { rootSelectors } from '@redux/modules/selectors';
import { fetchServerTimeRequest } from '@redux/modules/api/actions';
import { DateTime } from 'luxon';
import schema from '../../../../schema';
import {
  formIsSigned, hipaaIsSigned, shouldShowHipaaPsych, shouldShowHipaaSubstance
} from '../../../../validators/releases';
import { SignatureValidator } from '../../../../validators';
import FormStatus from '../FormStatus';
import BasicAccordion from '../BasicAccordion';
import AdditionalComments from '../AdditionalComments';
import Verify from '../Verify';
import General from '../General';
import Medical from '../Medical';
import Credit from '../Credit';
import SubmitConfirmationModal from '../SubmitConfirmationModal';
import HipaaOptionalConfirmationModal from '../HipaaOptionalConfirmationModal';
import connectPackageSection from '../PackageConnector';

const signatureValid = (data) => new SignatureValidator(data).isValid();

export class PackageSubmit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isConfirmingSubmission: false,
      isSubmitting: false,
      retrivingDraft: false,
      submissionError: false,
      showAdditionalComments: true,
      showGeneralItem: false,
      showCreditItem: false,
      signatures: { ...this.props.Submission.Releases },
      spinnerAction: SpinnerAction.Spin,
      submissionErrorCode: 0,
      submissionErrorBody: '',
      submissionErrorTime: new Date(),
      serverTimeDiff: {},
      hipaaConfirmationWarningDismissed: false,
    };
    this.retrieveDraftPDF = this.retrieveDraftPDF.bind(this);
    this.retrieveDraftPDF = debounce(this.retrieveDraftPDF, 20000, { leading: true, trailing: false });
    this.renderDraftPDF = this.renderDraftPDF.bind(this);
  }

  componentDidMount() {
    // This is a catchall to revalidate the entire form as it does on form load.
    // It will catch instances where one validation depended on a value in another section
    this.props.dispatch(validateForm());
    const emptySignature = {
      Signature: {
        Name: {},
        Date: {},
      },
    };

    // This will get and store the server time difference for later use
    this.getServerTimeDiff();

    // this will clear all the signatures from the form when the release section is selected.
    this.update({
      Medical: emptySignature,
      General: emptySignature,
      Credit: emptySignature,
      AdditionalComments: emptySignature,
    });
  }

  // Obtain the difference between local time and server time for later use
  getServerTimeDiff() {
    if (!this.props.hasFetchResponses?.serverTime) {
      this.props.dispatch(fetchServerTimeRequest());
    }

    api.getServerTime().then((response) => {
      this.setState({
        serverTimeDiff: DateTime.fromISO(response.data.utcTime).diff(DateTime.utc()),
      });
    }).catch((err) => console.error(err));
  }

  componentDidUpdate(prevProps) {
    const {
      submissionHasError,
      submissionComplete
    } = this.props;
    if (prevProps.submissionHasError !== submissionHasError && submissionHasError) {
      this.handleSubmissionError();
    }
    if (prevProps.submissionComplete !== submissionComplete && submissionComplete) {
      this.handleSubmissionComplete();
    }
  }

  handleSubmissionComplete = () => {
    const {
      statusResponse,
      updateApplication,
      history
    } = this.props;

    const statusData = statusResponse?.data || {
      Locked: false,
      Hash: false,
    };

    updateApplication('Settings', 'status', statusData.Status);
    updateApplication('Settings', 'hash', statusData.Hash);

    history.push('/locked');
  };

  handleSubmissionError = () => {
    const {
      submissionType,
      submissionError,
    } = this.props;

    const submissionStageFail = `Failed during ${submissionType} stage`;
    console.warn(submissionStageFail);

    const errTime = new Date();
    const errorSaveCode = [submissionTypes.saveAll, submissionTypes.saveSignatures].includes(submissionType) ? ` (${getErrorCode(submissionError?.response).code.toString()})` : '';
    const errorMessage = submissionError?.response?.data?.errors[0]?.message || 'Unknown Error';

    const structuredErrorMessage = `${errorMessage}${errorSaveCode}. ${submissionStageFail}.`;
    const errorBody = `${submissionError?.response?.data?.errors[0]?.body || ''} ${structuredErrorMessage}`;
    const errorCode = submissionError?.response?.status || 599; // using 599 as the unknown browser error code
    console.warn(`Code: ${errorCode}, Message: ${structuredErrorMessage} @ ${errTime.toISOString()}`);

    this.setState({
      isSubmitting: false,
      isConfirmingSubmission: true,
      submissionError: true,
      submissionErrorCode: errorCode,
      submissionErrorBody: errorBody,
      submissionErrorTime: errTime,
    });
  };

  handleConfirmSubmission = () => {
    this.setState({
      isConfirmingSubmission: true,
      submissionError: false,
      submissionErrorCode: 0,
    });
  };

  handleHipaaCancel = () => {
    this.setState({
      isConfirmingSubmission: false,
    });
  };

  handleHipaaDismiss = () => {
    this.setState({
      hipaaConfirmationWarningDismissed: true,
    });
  };

  handleCancel = () => {
    this.setState({
      isConfirmingSubmission: false,
      hipaaConfirmationWarningDismissed: false,
    });
  };

  handleSubmit = async () => {
    const { signatures } = this.state;

    const data = { ...signatures };
    const signaturesPayload = schema('package.submit', data, false);

    this.setState({
      isSubmitting: true,
      isConfirmingSubmission: false,
    });

    // Submit will trigger chain of api calls, requiring success prior to next step: save all, save signatures, submit, etc.
    this.props.dispatch(startSubmission(signaturesPayload));
  };

  update = (values) => {
    const { signatures } = this.state;

    this.setState({
      signatures: {
        ...signatures,
        ...values,
      },
    });
  };

  updateComments = (values) => {
    this.update({ AdditionalComments: values });
  };

  updateGeneral = (values) => {
    this.update({ General: values });
  };

  updateMedical = (values) => {
    this.update({ Medical: values });
  };

  updateCredit = (values) => {
    this.update({ Credit: values });
  };

  togglePanel = (panel, scrollIntoView = true) => {
    const { showAdditionalComments, showGeneralItem, showCreditItem } = this.state;

    const newState = {
      showAdditionalComments: false,
      showGeneralItem: false,
      showCreditItem: false,
      scrollIntoView: null,
    };

    switch (panel) {
      case 'additionalComments':
        newState.showAdditionalComments = !showAdditionalComments;
        newState.scrollIntoView = scrollIntoView && 'additionalComments';
        break;

      case 'generalItem':
        newState.showGeneralItem = !showGeneralItem;
        newState.scrollIntoView = scrollIntoView && 'generalItem';
        break;

      case 'creditItem':
        newState.showCreditItem = !showCreditItem;
        newState.scrollIntoView = scrollIntoView && 'creditItem';
        break;

      default:
    }

    this.setState(newState);
  };

  // This retrieves a draft PDF. this should be debounced.
  retrieveDraftPDF = () => {
    // TODO: Need to take this through the same logic as submit logic.  Should save first and then get draft
    this.props.dispatch(saveAllForPDFRequest());

    const fileNow = new Date().toISOString().replace(/[:.\-]/g, '');
    const filename = `draft_review_${this.props.Settings.formType}_${fileNow}.pdf`;
    this.setState({ retrivingDraft: true });
    api.getDraftPdf()?.then((response) => {
      const blob = new Blob([response.data], { type: 'application/octet-stream' });
      FileSaver.saveAs(blob, filename);
      this.setState({ retrivingDraft: false });
    }).catch((e) => {
      try {
        const errTime = new Date();
        const structuredErrorMessage = e?.response?.data?.errors[0]?.message || 'Unknown Error';
        const errorBody = e?.response?.data?.errors[0]?.body || '';
        const errorCode = e?.response?.status || 599; // using 599 as the unknown browser error code
        console?.warn(`Failed to get draft pdf Code: ${errorCode}, Message: ${structuredErrorMessage} @ ${errTime.toISOString()}`);
        this.setState({
          isSubmitting: false,
          isConfirmingSubmission: true,
          submissionError: true,
          submissionErrorCode: errorCode,
          submissionErrorBody: errorBody,
          submissionErrorTime: errTime,
        });
      } catch (err) {
        console?.error(err);
      }
      this.setState({ retrivingDraft: false });
    });
  };

  renderDraftPDF = () => {
    const { retrivingDraft } = this.state;
    const text = retrivingDraft ? 'Retrieving Draft PDF For Review' : 'Download a Draft PDF For Review';
    const draftPDFButton = (
      <div><button type="button" onClick={this.retrieveDraftPDF}>{text}</button></div>
    );
    return draftPDFButton;
  };

  renderAccordion = (formType) => {
    const { Application = {}, Identification = {}, History = {} } = this.props;
    const { signatures } = this.state;

    const { ApplicantName = {} } = Identification;

    const {
      showAdditionalComments, showGeneralItem, showCreditItem, scrollIntoView
    } = this.state;

    const showHipaaPsych = shouldShowHipaaPsych(Application);
    const showHipaaSubstance = shouldShowHipaaSubstance(Application);
    const hideHippaSection = !(showHipaaPsych || showHipaaSubstance);

    const additionalCommentsSignatureValid = signatureValid(signatures.AdditionalComments);
    const generalItemSignatureValid = signatureValid(signatures.General);
    const medicalSignatureValid = hideHippaSection || (!hideHippaSection && signatureValid(signatures.Medical));
    const creditSignatureValid = signatureValid(signatures.Credit);

    let accordionItems;
    switch (formType) {
      case PVQ_A:
      case PVQ_A_B:
      case PVQ_A_B_C:
      case PVQ_A_B_D:
        accordionItems = [
          {
            title: i18n.t('application.validForm.certificationItem'),
            valid: () => additionalCommentsSignatureValid,
            onClick: () => {
              this.togglePanel('additionalComments', false);
            },
            open: showAdditionalComments,
            scrollIntoView: scrollIntoView === 'additionalComments',
            component: () => (
              <div>
                <AdditionalComments
                  {...signatures.AdditionalComments}
                  onUpdate={this.updateComments}
                  LegalName={ApplicantName}
                  formType={formType}
                />
                <Show when={additionalCommentsSignatureValid}>
                  <button
                    type="button"
                    className="next-release"
                    onClick={() => {
                      this.togglePanel('generalItem');
                    }}
                  >
                    {i18n.t('application.validForm.next')}
                  </button>
                </Show>
              </div>
            ),
          },
          {
            title: i18n.t('application.validForm.generalItem'),
            valid: () => generalItemSignatureValid,
            onClick: () => {
              this.togglePanel('generalItem', false);
            },
            open: showGeneralItem,
            scrollIntoView: scrollIntoView === 'generalItem',
            component: () => (
              <div>
                <Verify Identification={Identification} History={History} />
                <hr />
                <General
                  {...signatures.General}
                  formType={formType}
                  onUpdate={this.updateGeneral}
                  LegalName={ApplicantName}
                />
                <Show when={!hideHippaSection}>
                  <div>
                    <hr />
                    <Medical
                      {...signatures.Medical}
                      formType={formType}
                      onUpdate={this.updateMedical}
                      LegalName={ApplicantName}
                    />
                  </div>
                </Show>
                <Show when={generalItemSignatureValid && medicalSignatureValid}>
                  <button
                    type="button"
                    className="next-release"
                    onClick={() => {
                      this.togglePanel('creditItem');
                    }}
                  >
                    {i18n.t('application.validForm.next')}
                  </button>
                </Show>
              </div>
            ),
          },
          {
            title: i18n.t('application.validForm.creditItem'),
            valid: () => creditSignatureValid,
            onClick: () => {
              this.togglePanel('creditItem', false);
            },
            open: showCreditItem,
            scrollIntoView: scrollIntoView === 'creditItem',
            component: () => (
              <div>
                <Credit
                  {...signatures.Credit}
                  onUpdate={this.updateCredit}
                  LegalName={ApplicantName}
                />
              </div>
            ),
          },
        ];
        break;
      case SF86:
        accordionItems = [
          {
            title: i18n.t('application.validForm.certificationItem'),
            valid: () => additionalCommentsSignatureValid,
            onClick: () => {
              this.togglePanel('additionalComments', false);
            },
            open: showAdditionalComments,
            scrollIntoView: scrollIntoView === 'additionalComments',
            component: () => (
              <div>
                <AdditionalComments
                  {...signatures.AdditionalComments}
                  onUpdate={this.updateComments}
                  LegalName={ApplicantName}
                  formType={formType}
                />
                <Show when={additionalCommentsSignatureValid}>
                  <button
                    type="button"
                    className="next-release"
                    onClick={() => {
                      this.togglePanel('generalItem');
                    }}
                  >
                    {i18n.t('application.validForm.next')}
                  </button>
                </Show>
              </div>
            ),
          },
          {
            title: i18n.t('application.validForm.generalItem'),
            valid: () => generalItemSignatureValid,
            onClick: () => {
              this.togglePanel('generalItem', false);
            },
            open: showGeneralItem,
            scrollIntoView: scrollIntoView === 'generalItem',
            component: () => (
              <div>
                <Verify Identification={Identification} History={History} />
                <hr />
                <General
                  {...signatures.General}
                  formType={formType}
                  onUpdate={this.updateGeneral}
                  LegalName={ApplicantName}
                />
                <Show when={!hideHippaSection}>
                  <div>
                    <hr />
                    <Medical
                      {...signatures.Medical}
                      formType={formType}
                      onUpdate={this.updateMedical}
                      LegalName={ApplicantName}
                    />
                  </div>
                </Show>
                <Show when={generalItemSignatureValid && medicalSignatureValid}>
                  <button
                    type="button"
                    className="next-release"
                    onClick={() => {
                      this.togglePanel('creditItem');
                    }}
                  >
                    {i18n.t('application.validForm.next')}
                  </button>
                </Show>
              </div>
            ),
          },
          {
            title: i18n.t('application.validForm.creditItem'),
            valid: () => creditSignatureValid,
            onClick: () => {
              this.togglePanel('creditItem', false);
            },
            open: showCreditItem,
            scrollIntoView: scrollIntoView === 'creditItem',
            component: () => (
              <div>
                <Credit
                  {...signatures.Credit}
                  onUpdate={this.updateCredit}
                  LegalName={ApplicantName}
                />
              </div>
            ),
          },
        ];
        break;
      case SF85:
      case SF85P:
      case SF85PS:
        accordionItems = [
          {
            title: i18n.t('application.validForm.certificationItem'),
            valid: () => additionalCommentsSignatureValid,
            onClick: () => {
              this.togglePanel('additionalComments', false);
            },
            open: showAdditionalComments,
            scrollIntoView: scrollIntoView === 'additionalComments',
            component: () => (
              <div>
                <AdditionalComments
                  {...signatures.AdditionalComments}
                  onUpdate={this.updateComments}
                  LegalName={ApplicantName}
                  formType={formType}
                />
                <Show when={additionalCommentsSignatureValid}>
                  <button
                    type="button"
                    className="next-release"
                    onClick={() => {
                      this.togglePanel('generalItem');
                    }}
                  >
                    {i18n.t('application.validForm.next')}
                  </button>
                </Show>
              </div>
            ),
          },
          {
            title: [SF85P, SF85PS].includes(formType) ? i18n.t('application.validForm.generalItem') : i18n.t('application.validForm.general85Item'),
            valid: () => generalItemSignatureValid,
            onClick: () => {
              this.togglePanel('generalItem', false);
            },
            open: showGeneralItem,
            scrollIntoView: scrollIntoView === 'generalItem',
            component: () => (
              <div>
                <Verify Identification={Identification} History={History} />
                <hr />
                <General
                  {...signatures.General}
                  formType={formType}
                  onUpdate={this.updateGeneral}
                  LegalName={ApplicantName}
                />
                <Show when={([SF85P, SF85PS].includes(formType) && !hideHippaSection)}>
                  <div>
                    <hr />
                    <Medical
                      {...signatures.Medical}
                      formType={formType}
                      onUpdate={this.updateMedical}
                      LegalName={ApplicantName}
                    />
                  </div>
                </Show>
                <Show when={generalItemSignatureValid && ([SF85P, SF85PS].includes(formType) ? medicalSignatureValid : true)}>
                  <button
                    type="button"
                    className="next-release"
                    onClick={() => {
                      this.togglePanel('creditItem');
                    }}
                  >
                    {i18n.t('application.validForm.next')}
                  </button>
                </Show>
              </div>
            ),
          },
          {
            title: i18n.t('application.validForm.creditItem'),
            valid: () => creditSignatureValid,
            onClick: () => {
              this.togglePanel('creditItem', false);
            },
            open: showCreditItem,
            scrollIntoView: scrollIntoView === 'creditItem',
            component: () => (
              <div>
                <Credit
                  {...signatures.Credit}
                  onUpdate={this.updateCredit}
                  LegalName={ApplicantName}
                />
              </div>
            ),
          },
        ];
        break;
      default:
        // case 'SF852013':
        accordionItems = [
          {
            title: i18n.t('application.validForm.certificationItem'),
            valid: () => additionalCommentsSignatureValid,
            onClick: () => {
              this.togglePanel('additionalComments', false);
            },
            open: showAdditionalComments,
            scrollIntoView: scrollIntoView === 'additionalComments',
            component: () => (
              <div>
                <AdditionalComments
                  {...signatures.AdditionalComments}
                  formType={formType}
                  onUpdate={this.updateComments}
                  LegalName={ApplicantName}
                />
                <Show when={additionalCommentsSignatureValid}>
                  <button
                    type="button"
                    className="next-release"
                    onClick={() => {
                      this.togglePanel('generalItem');
                    }}
                  >
                    {i18n.t('application.validForm.next')}
                  </button>
                </Show>
              </div>
            ),
          },
          {
            title: i18n.t('application.validForm.general85Item'),
            valid: () => generalItemSignatureValid,
            onClick: () => {
              this.togglePanel('generalItem', false);
            },
            open: showGeneralItem,
            scrollIntoView: scrollIntoView === 'generalItem',
            component: () => (
              <div>
                <General
                  {...signatures.General}
                  formType={formType}
                  onUpdate={this.updateGeneral}
                  LegalName={ApplicantName}
                />
                <hr />
                <Verify Identification={Identification} History={History} />
              </div>
            ),
          },
        ];
        break;
    }

    return <BasicAccordion items={accordionItems} />;
  };

  getSubmissionStageText = (formName) => {
    const { submissionType } = this.props;
    let submissionStateText = `Your ${formName} is being submitted.`;
    if (submissionType === submissionTypes.saveAll) {
      submissionStateText += ' Saving all form data.';
    } else if (submissionType === submissionTypes.saveSignatures) {
      submissionStateText += ' Saving form signatures.';
    } else if (submissionType === submissionTypes.submit) {
      submissionStateText += ' Transmitting package.';
    } else if (submissionType === submissionTypes.status) {
      submissionStateText += ' Retrieving final status';
    }
    return submissionStateText;
  };

  render() {
    if (this.props.isComplete === false && this.props.initialValidateFormCompleted === true) { return <Redirect to="/form" />; }

    const { Application = {}, Settings = {} } = this.props;
    const {
      signatures,
      isSubmitting,
      isConfirmingSubmission,
      submissionError,
      submissionErrorCode,
      submissionErrorBody,
      submissionErrorTime,
      spinnerAction,
      hipaaConfirmationWarningDismissed
    } = this.state;
    const { formType } = Settings;
    const formName = formType && formConfig[formType] && formConfig[formType].FORM_LABEL;

    const showDraftPdf = (!env.DisableDraftPDF());

    const classes = classnames('eapp-submit', 'submission-status', 'valid');

    const showHipaaPsych = shouldShowHipaaPsych(Application);
    const showHipaaSubstance = shouldShowHipaaSubstance(Application);
    const isHipaaSigned = !(showHipaaPsych || showHipaaSubstance) ? false : hipaaIsSigned(signatures, formType);
    const isSigned = formIsSigned(signatures, showHipaaPsych, formType);

    const buttonText = isSubmitting
      ? i18n.t('application.validForm.submitting')
      : i18n.t('application.validForm.submit', { formName });

    const submissionSpinnerText = this.getSubmissionStageText(formName);

    return (
      <div className={classes}>
        {i18n.m('application.submissionStatus.valid')}
        <FormStatus isValid isTransitioning={false} />

        <div className="valid-form">
          {i18n.m('application.submissionStatus.valid2')}
          {i18n.m('releases.additionalComments.contents')}

          {showDraftPdf === true && this.renderDraftPDF()}

          {this.renderAccordion(formType)}

          <div className="text-right">
            <Show when={!isSigned}>
              <div className="usa-alert usa-alert-warning">
                <div className="usa-alert-body">
                  <h3 className="usa-alert-heading">
                    Signatures not complete
                  </h3>
                </div>
              </div>
            </Show>
            <button
              type="button"
              onClick={this.handleConfirmSubmission}
              className="submit usa-button"
              disabled={isSubmitting || !isSigned}
            >
              <div className="submit-arrow-button">
                {buttonText}
                <div className="arrow-circle-right">
                  <SvgComponent className="arrow-circle-right" src="/img/arrow-circle-right.svg" />
                </div>
              </div>
            </button>
          </div>
        </div>

        {submissionError && (
          <div className="field">
            <div className="table">
              <div className="messages">
                <div className="usa-alert usa-alert-error" role="alert">
                  <div className="usa-alert-body">
                    {i18n.m('error.submission.message', { formName })}
                    {submissionErrorCode === 409
                      && <>{i18n.m('error.submissionCommunication.message', { errorCode: submissionErrorCode, errorTime: submissionErrorTime.toISOString() })}</>}
                    {submissionErrorBody !== ''
                      && <>{i18n.m('error.submissionErrorBody.message', { errorBody: submissionErrorBody })}</>}
                    {i18n.m('error.submissionErrorCode.message', { errorCode: submissionErrorCode, errorTime: submissionErrorTime.toISOString() })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {
          showHipaaSubstance && !showHipaaPsych && !isHipaaSigned && !hipaaConfirmationWarningDismissed ? (
            <HipaaOptionalConfirmationModal
              handleHipaaCancel={this.handleHipaaCancel}
              handleHipaaDismiss={this.handleHipaaDismiss}
              show={isConfirmingSubmission}
            />
          ) : (
            <SubmitConfirmationModal
              formName={formName}
              submissionErred={submissionError}
              submissionErrorCode={this.state.submissionErrorCode}
              submissionErrorBody={this.state.submissionErrorBody}
              submissionErrorTime={this.state.submissionErrorTime}
              handleCancel={this.handleCancel}
              handleSubmit={this.handleSubmit}
              show={isConfirmingSubmission}
              serverTimeDiff={this.state.serverTimeDiff}
            />
          )
        }

        {isSubmitting && (
          <div className="spinner eapp-submit__spinner-bg">
            <div className="eapp-submit__spinner-container">
              <Spinner
                className="eapp-submit__spinner-container"
                show
                action={spinnerAction}
                label={submissionSpinnerText}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

PackageSubmit.propTypes = {
  Application: PropTypes.object,
  Identification: PropTypes.object,
  History: PropTypes.object,
  Submission: PropTypes.object,
  updateApplication: PropTypes.func,
  history: PropTypes.object,
  Settings: PropTypes.object,
  isComplete: PropTypes.bool,
  initialValidateFormCompleted: PropTypes.bool,
  dispatch: PropTypes.func,
};

PackageSubmit.defaultProps = {
  Application: {},
  Identification: {},
  History: {},
  Submission: {},
  updateApplication: () => { },
  history: { push: () => { } },
  Settings: { formType: '' },
};

/**
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  isLoading: rootSelectors.api.isLoading(state),
  hasFetchResponses: rootSelectors.api.hasFetchResponses(state),
});

export default connect(mapStateToProps)(connectPackageSection(PackageSubmit));
